var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M414.71,226.28L401,208c-47.118-62.823-123.335-102-205-102h-61C60.561,106,0,166.561,0,241v90c0,24.813,20.187,45,45,45 h23.072c10.391,17.916,29.769,30,51.928,30s41.537-12.084,51.928-30h168.144c10.391,17.916,29.769,30,51.928,30 s41.537-12.084,51.928-30H497c8.284,0,15-6.716,15-15v-30C512,275.803,469.106,230.248,414.71,226.28z M377,226h-75v-30h47.842 C359.732,205.105,368.843,215.125,377,226z M120,376c-16.542,0-30-13.458-30-30s13.458-30,30-30s30,13.458,30,30 S136.542,376,120,376z M392,376c-16.542,0-30-13.458-30-30s13.458-30,30-30s30,13.458,30,30S408.542,376,392,376z M482,346h-30 c0-33.084-26.916-60-60-60s-60,26.916-60,60H180c0-33.084-26.916-60-60-60s-60,26.916-60,60H45c-8.271,0-15-6.729-15-15v-15h15 c8.284,0,15-6.716,15-15s-6.716-15-15-15H30v-45c0-57.897,47.103-105,105-105h61c39.984,0,78.889,10.649,112.8,30 c-7.507,0-165.125,0-173.8,0c-41.355,0-75,33.645-75,75c0,8.284,6.716,15,15,15c17.555,0,314.468,0,332,0 c24.485,0,46.264,11.797,59.961,30.002C458.695,286.023,452,292.729,452,301c0,8.284,6.716,15,15,15h13.491 c0.988,4.848,1.509,9.864,1.509,15V346z M272,196v30h-61v-30H272z M181,196v30H92.57c6.191-17.461,22.874-30,42.43-30H181z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.46d6716b1306b515f10aac377705f80f.svg";
export { ForwardRef as ReactComponent };